import { Spacing } from '@vkontakte/vkui';
import React from 'react';
import { Placeholder } from 'reactApp/ui/Placeholder/Placeholder';

import styles from './FamilyCardLoader.css';

export const FamilyCardLoader: React.FC = () => {
    return (
        <div className={styles.root}>
            <Spacing size={13} />
            <div className={styles.spaceWrapper}>
                <div className={styles.space}>
                    <Placeholder />
                </div>
                <div className={styles.units}>
                    <Placeholder />
                </div>
            </div>
            <Spacing size={22} />
            <div className={styles.button}>
                <Placeholder />
            </div>
        </div>
    );
};
